export const validateEmail = email => /\S+@\S+\.\S+/.test(email);

export const validatePhone = phone => {
  // return /^([0-9]{2})?(\([0-9]{2})\)([0-9]{3}|[0-9]{4})-[0-9]{4}$/i.test(phone);
  // const regex = new RegExp(
  //   '/^\\([0-9]{2}\\)((3[0-9]{3}-[0-9]{4})|(9[0-9]{3}-[0-9]{5}))$'
  // );

  // return regex.test(phone);
  return true;
};

export const getPhoneMask = () => [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
